<template>
  <div class="afu-wa-preview">
    <div class="qr-preview-panel">
      <div class="qr-preview-header">
        <div>
          <h6>{{ title }}</h6>
          <p>{{ description }}</p>
        </div>
        <div v-if="steps.length > 1" class="afu-preview-select">
          <select
            class="afu-preview-select-input"
            :value="safeIndex"
            aria-label="Pilih pesan untuk dipreview"
            @change="onSelectStep"
          >
            <option v-for="(step, index) in steps" :key="step._key || step.id || index" :value="index">
              {{ stepOptionLabel(index) }}
            </option>
          </select>
          <i class="fa fa-chevron-down"></i>
        </div>
        <span v-else class="qr-preview-badge">
          {{ steps.length ? "Pesan 1" : "Contoh" }}
        </span>
      </div>

      <div class="qr-preview-canvas">
        <quick-reply-preview
          v-if="activeStep"
          :preview-data="previewData"
          :buttons-rows="[]"
          :link-rows="[]"
          :text-reply-rows="[]"
          :timestamp="previewTime"
          :check-count="2"
          safe-format
        />
        <div v-else class="afu-preview-empty">
          <i class="fa fa-comment-o"></i>
          <p>Belum ada pesan untuk dipreview.</p>
        </div>
      </div>

      <div class="qr-preview-note">
        <i class="fa fa-info-circle"></i>
        <div>
          <strong>Preview menggunakan contoh data.</strong>
          <span>Nama: Jojo &middot; Nomor: 6281234567890</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuickReplyPreview from "@/views/automation/quickReply/preview.vue";

const MEDIA_TYPES = ["image", "video", "document"];

function fileNameFromUrl(url) {
  const text = String(url || "");
  if (!text) {
    return "";
  }
  const clean = text.split("?")[0].split("#")[0];
  const parts = clean.split("/");
  return parts[parts.length - 1] || "";
}

export default {
  name: "AfuWhatsAppPreview",
  components: {
    QuickReplyPreview
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "Preview WhatsApp"
    },
    description: {
      type: String,
      default: "Ini adalah contoh tampilan pesan di WhatsApp."
    }
  },
  data() {
    return {
      previewTime: "08:50"
    };
  },
  computed: {
    safeIndex() {
      const total = (this.steps || []).length;
      if (!total) {
        return 0;
      }
      const index = Number(this.activeIndex);
      if (!isFinite(index)) {
        return 0;
      }
      return Math.min(Math.max(index, 0), total - 1);
    },
    activeStep() {
      return (this.steps || [])[this.safeIndex] || null;
    },
    normalizedType() {
      const type = this.activeStep ? this.activeStep.message_type : "";
      return MEDIA_TYPES.indexOf(type) !== -1 ? type : "text";
    },
    previewData() {
      const step = this.activeStep;
      if (!step) {
        return {
          header: {
            message: "",
            message_type: "text",
            image_url: "",
            media_name: "",
            footer_message: "",
            footer_message_status: false,
            button_type: "text_reply"
          },
          detail_button: []
        };
      }

      const mediaUrl = String(step.message_media || "");
      return {
        header: {
          message: step.message_content || "",
          message_type: this.normalizedType,
          image_url: mediaUrl,
          media_name:
            step.media_name ||
            step.message_media_name ||
            fileNameFromUrl(mediaUrl),
          footer_message: "",
          footer_message_status: false,
          button_type: "text_reply"
        },
        detail_button: []
      };
    }
  },
  methods: {
    stepOptionLabel(index) {
      return "Pesan " + (index + 1);
    },
    onSelectStep(event) {
      this.$emit("update:activeIndex", Number(event.target.value) || 0);
    }
  }
};
</script>

<style scoped>
.afu-wa-preview {
  min-width: 0;
}

.qr-preview-panel {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);
}

.qr-preview-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 17px 18px 13px;
  border-bottom: 1px solid #eef2f7;
}

.qr-preview-header h6 {
  margin: 0;
  color: #101828;
  font-size: 14px;
  font-weight: 700;
}

.qr-preview-header p {
  margin: 3px 0 0;
  color: #98a2b3;
  font-size: 11px;
}

.qr-preview-badge {
  flex: 0 0 auto;
  padding: 3px 7px;
  color: #b45309;
  background: #fff7e8;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
}

.afu-preview-select {
  position: relative;
  flex: 0 0 auto;
  min-width: 108px;
}

.afu-preview-select-input {
  width: 100%;
  height: 30px;
  padding: 0 24px 0 10px;
  color: #344054;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 28px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.afu-preview-select-input:focus {
  border-color: #f99a43;
  outline: 0;
  box-shadow: 0 0 0 3px rgba(249, 154, 67, 0.14);
}

.afu-preview-select .fa {
  position: absolute;
  top: 50%;
  right: 9px;
  color: #98a2b3;
  font-size: 9px;
  pointer-events: none;
  transform: translateY(-50%);
}

.qr-preview-canvas {
  min-height: 320px;
  max-height: 520px;
  padding: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #efeae2;
  background-image: radial-gradient(rgba(255, 255, 255, 0.35) 1px, transparent 1px);
  background-size: 18px 18px;
}

.qr-preview-canvas /deep/ .chat {
  background: transparent;
}

.qr-preview-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  color: #667085;
  background: #f0f7ff;
  font-size: 11px;
  line-height: 1.5;
}

.qr-preview-note i {
  margin-top: 2px;
  color: #2e90fa;
}

.qr-preview-note strong,
.qr-preview-note span {
  display: block;
}

.qr-preview-note strong {
  color: #344054;
  font-weight: 700;
}

.afu-preview-empty {
  padding: 80px 12px;
  color: #8696a0;
  text-align: center;
}

.afu-preview-empty .fa {
  font-size: 28px;
}

.afu-preview-empty p {
  margin: 10px 0 0;
  font-size: 12px;
}

@media (max-width: 575.98px) {
  .qr-preview-header {
    align-items: stretch;
    flex-direction: column;
  }

  .afu-preview-select {
    width: 100%;
  }

  .qr-preview-canvas {
    min-height: 260px;
    max-height: 420px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/autoFollowUp/components/AfuWhatsAppPreview.vue